import { Component } from '@angular/core';


/**
 * This component adds an "(Optional)" tag to the form field label
 */
@Component({
  selector: 'app-optional',
  template: '<span class="optional">{{i18nOptionalField}}</span>',
  styleUrls: ['./form-optional-field.component.scss'],
})

export class FormOptionalFieldComponent {
  public i18nOptionalField: string  = $localize`:@@general.formLabel.optional:(optional)`;
  constructor() { }

}
